import { Attachment, Translations, UUID } from '@/types/types';
import { QueryKey } from '@/configs/queryKeys';
import { Asset } from './AssetApi';
import { ProductModuleCollection } from './ProductModuleCollectionApi';
import { PriceGroup } from './PriceGroupApi';
import EntityApi, { BaseEntity } from './EntityApi';

export enum ProductModuleType {
	LINE = 'LINE',
	LEFT = 'LEFT',
	RIGHT = 'RIGHT',
}

export interface ProductModulePriceGroup extends BaseEntity {
	priceGroup: PriceGroup;
	price: number;
}

export interface ProductModule extends BaseEntity {
	name: string;
	code: string;
	description: string;
	image?: Attachment;
	productModuleCollection: ProductModuleCollection;
	price: number;
	asset: Asset;
	listOrder: number;
	moduleType: ProductModuleType;
	productModulePriceGroups: ProductModulePriceGroup[];
	modulesBlacklistIds: UUID[];
	translations: Translations<{
		name: string;
		description: string;
	}>;
}

class ProductModuleApi extends EntityApi<ProductModule> {
	constructor() {
		super(QueryKey.productModules);
	}
}

export default new ProductModuleApi();
